import { render, staticRenderFns } from "./EmojiTopList.vue?vue&type=template&id=77d5483b&scoped=true"
import script from "./EmojiTopList.vue?vue&type=script&lang=js"
export * from "./EmojiTopList.vue?vue&type=script&lang=js"
import style0 from "./EmojiTopList.vue?vue&type=style&index=0&id=77d5483b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d5483b",
  null
  
)

export default component.exports